angular.module('NiacsProjectApp.review',[
    'NiacsProjectApp.services-strategy',
    'NiacsProjectApp.services-resources'
])
.directive('niacsReviewApp',[function(){
    return {
        restrict: 'C',
        scope: {},
        template:
        '<div class="review-sectors"></div>'+
        '<div class="review-var-list"></div>',
        controller: ['$scope',function($scope) {
            $scope.filter = {
                sectors: 'niacs_strategy_far2'
            };
        }]
    };
}])
.directive('reviewSectors',['NiacsStrategyService',function(NiacsStrategyService){
    return {
        restrict: 'C',
        template: '<form><label class="radio-inline" ng-repeat="source in strategySources">'+
        '<input type="radio" ng-model="filter.sectors" ng-value="source.getSource()" name="strategySourceRadio" id="strategySourceRadio-{{source.getSource()}}"></input>'+
        ' {{source.getSourceTitle()}}</label></form>',
        link: function($scope) {
            NiacsStrategyService.getSources().then(function(sources) {
                $scope.strategySources = sources;
            });
        }
    };
}])
.directive('reviewVarList',['NiacsVulnAssmntRegion',function(NiacsVulnAssmntRegion) {
    return {
        restrict: 'C',
        template: '<ul class="list-unstyled">'+
        '<li ng-repeat="var in vars" var="var" class="review-var" ng-class="{deprecated: var.deprecated}" filter="filter"></li>'+
        '</ul>',
        link: function($scope) {
            NiacsVulnAssmntRegion.query({sort: 'title',includeDeprecated:true},function(vars) {
                $scope.vars = vars.list;
            });
        }
    };
}])
.directive('reviewVar',[function() {
    return {
        restrict: 'C',
        template: '<h3><review-link item="var"></review-link> <a href ng-click="toggle()"><fa-icon icon="{{visible ? \'compress-alt\' : \'expand-alt\'}}"></fa-icon></a></h3>'+
        '<div class="review-state-list" ng-if="visible">'+
        '<span ng-if="var.state.length"><label>States:</label> {{var.state.join(\', \')}}</span>'+
        '<label ng-if="!var.state.length">Has non-state specific boundaries.</label>'+
        '</div>'+
        '<div ng-if="loaded" ng-show="visible" class="review-unit-list" var="var" filter="filter"></div>'+
        '<div ng-if="loaded" ng-show="visible" class="review-cis-list" prefix="Regional " target="var" filter="filter" heading="h4"></div>',
        scope: {
            var: '=',
            filter: '='
        },
        link: function($scope) {
            $scope.loaded = false;
            $scope.visible = false;
            $scope.toggle = function() {
                if(!$scope.loaded) {
                    $scope.loaded = $scope.visible = true;
                } else {
                    $scope.visible = !$scope.visible;
                }
            };
        }
    };
}])
.directive('reviewUnitList',['$http','$filter',function($http,$filter){
    var filter = $filter('filter');
    return {
        restrict: 'C',
        template: '<h4>Units</h4><ul class="list-unstyled">'+
        '<li ng-if="filteredList.length === 0">None</li>'+
        '<li ng-repeat="unit in getFilteredList()" class="review-unit" unit="unit" filter="filter"></li>'+
        '</ul>',
        scope: {
            var: '=',
            filter: '='
        },
        link: function($scope) {
            $scope.getFilteredList = function() {
                return $scope.filteredList = filter($scope.units,$scope.filter);
            };
            $scope.var.$getUnits().then(function(units) {
                $scope.units = units;
            });
        }
    };
}])
.directive('reviewLink',[function(){
    return {
        restrict: 'E',
        replace: true,
        template: '<div class="review-link"><a target="_blank" ng-href="/node/{{item.id}}/edit">{{item.label}}</a> '+
        '<a target="_blank" ng-href="/node/{{item.id}}/edit"><fa-icon icon="pencil"></fa-icon></a></div>',
        scope: {
            item: '='
        }
    };
}])
.directive('reviewUnit',[function(){
    return {
        restrict: 'C',
        template:'<h4><review-link item="unit"></review-link></h4>'+
        '<div class="review-cis-list" heading="h5" target="unit" filter="filter"></div>',
        scope: {
            unit: '=',
            filter: '='
        }
    };
}])
.directive('reviewCisList',['$http','$sce','$filter',function($http,$sce,$filter){
    var filter = $filter('filter');
    return {
        restrict: 'C',
        template: '<span ng-bind-html="headingHtml"></span><ul class="list-unstyled">'+
        '<li ng-if="filteredList.length === 0">None</li>'+
        '<li ng-repeat="statement in getFilteredList()"><review-link item="statement"></review-link></li>'+
        '</ul>',
        scope: {
            prefix: '@',
            heading: '@',
            target: '=',
            filter: '='
        },
        link: function($scope) {
            $scope.getFilteredList = function() {
                return $scope.filteredList = filter($scope.statements,$scope.filter);
            };
            $scope.headingHtml = $sce.trustAsHtml('<'+$scope.heading+'>'+($scope.prefix||'')+' Climate Impact Statements</'+$scope.heading+'>');
            $scope.target.$getClimateImpacts().then(function(statements) {
                $scope.statements = statements;
            });
        }
    };
}]);
